// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PaymentLogsController = function ($scope, $routeParams, $http, PaymentLogs, RequestLogsWeb) {
    $scope.paymentLogs = PaymentLogs.get({ transactionId: $routeParams.paymentId }, function (x) {
        if (!x.PSPWebhookLogs) return;
        x.PSPWebhookLogs.forEach(function (log) {
            if (!log.Request)
                RequestLogsWeb.single({ id: log.RequestLogId.Untyped }, function (x) { log._request = x.Request });
            else log._request = log.Request;
        });
    });

    $scope.BuildPgTransactionId = function (billwerkTransactionId) {
        const datePartOfId = new Date(parseInt(billwerkTransactionId.substring(0, 8), 16) * 1000).toISOString()
            .slice(0, 10)
            .replace(/-/g, '');
        return `${datePartOfId}-${billwerkTransactionId}`;
    }
};
PaymentLogsController.$inject = ['$scope', '$routeParams', '$http', 'PaymentLogs', 'RequestLogsWeb'];
